export default "__VITE_ASSET__ChroVztl__"